<template>
  <div v-show="isAdminPage" class="mt-3 ">
    <p class="mb-3">
      <b>Alkategóriák:</b>
    </p>
    <div class="wrapper">
      <div v-for="subCategory in subCategories" :key="subCategory._id">
        <div>
          <p class="sub-category-bubble d-flex justify-content-center align-items-center">
            <strong>
              {{ subCategory.title }}
            </strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CategoryApi from '../../../../api/fundMapCategories'
export default {
  data() {
    return {
      subCategories: []
    }
  },
  props: {
    isAdminPage: { type: Boolean, default: false },
    subCategoryIds: { type: Array }
  },
  async created() {
    try {
      this.subCategoryIds.forEach(async subCategoryId => {
        const result = await CategoryApi.getSubCategoryById(subCategoryId)

        this.subCategories.push(result)
      })
    } catch (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-category-bubble {
  background: #dfe6e9;
  width: 200px;
  padding: 4px 8px 4px 8px;
  border-radius: 8px;
}

.wrapper {
  display: grid;
  grid-template-columns: 200px minmax(10px, 3fr);
  grid-gap: 0.5rem;
  align-items: start;
}
</style>
